import React from "react";

const isString = v => typeof v === "string";

const flatten = array => {
  let newArray = [];

  array.forEach(item => {
    if (Array.isArray(item)) newArray = newArray.concat(item);
    else newArray.push(item);
  });

  return newArray;
};

const replaceString = (str, match, fn) => {
  if (str === "") return str;

  const result = str.split(match);

  // Apply fn to all odd elements result from the split
  for (let i = 1; i < result.length; i += 2) {
    result[i] = fn(result[i]);
  }

  return result;
};

// The result is rendered as a bare array of children, which React requires
// a `key` on for every element in it - plain string pieces don't need one.
const withKeys = array =>
  array.map((piece, index) =>
    React.isValidElement(piece)
      ? React.cloneElement(piece, { key: index })
      : piece
  );

// Also works with arrays of strings
// Non string values are left untouched
const reactStringReplace = (src, match, fn) => {
  let source = src;

  if (!Array.isArray(source)) source = [source];

  return withKeys(
    flatten(source.map(x => (isString(x) ? replaceString(x, match, fn) : x)))
  );
};

export default reactStringReplace;
